import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  sendMailsLoading: false,
  paperQueryLoading: false,
  error: null,
  activityLoading: false,
  activitiesByWeeklyLoading: false,
  customerQuery: [],
  paperQuery: [],
  activityLogs: [],
  activityLogsByWeekly: [],
  receipts: [],
  bill: [],
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    loadCustomerQueryRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadCustomerQuerySuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.customerQuery = action.payload.result;
    },
    loadCustomerQueryFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    loadCustomerActivityLogsRequested(state, action: PayloadAction<{}>) {
      state.activityLoading = true;
      state.error = null;
    },
    loadCustomerActivityLogsSuccess(state, action: PayloadAction<any>) {
      state.activityLoading = false;
      state.error = null;
      state.activityLogs = action.payload?.result;
    },
    loadCustomerActivityLogsFail(state, action: PayloadAction<{}>) {
      state.activityLoading = false;
      state.error = action.payload;
    },

    loadCustomerActivityLogsByWeeklyRequested(
      state,
      action: PayloadAction<{}>
    ) {
      state.activitiesByWeeklyLoading = true;
      state.error = null;
    },
    loadCustomerActivityLogsByWeeklySuccess(state, action: PayloadAction<any>) {
      state.activitiesByWeeklyLoading = false;
      state.error = null;
      state.activityLogsByWeekly = action.payload?.result;
    },
    loadCustomerActivityLogsByWeeklyFail(state, action: PayloadAction<{}>) {
      state.activitiesByWeeklyLoading = false;
      state.error = action.payload;
    },

    loadReceiptsRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    loadReceiptsSuccess(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = null;
      state.receipts = action.payload?.result;
    },
    loadReceiptsFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },

    sendMailRequested(state, action: PayloadAction<{}>) {
      state.sendMailsLoading = true;
      state.error = null;
    },
    sendMailSuccess(state, action: PayloadAction<any>) {
      state.sendMailsLoading = false;
      state.error = null;
      state.sendMails = action.payload?.result;
    },
    sendMailFail(state, action: PayloadAction<{}>) {
      state.sendMailsLoading = false;
      state.error = action.payload;
    },
    loadPaperQueryRequested(state, action: PayloadAction<{}>) {
      state.paperQueryLoading = true;
      state.error = null;
    },
    loadPaperQuerySuccess(state, action: PayloadAction<any>) {
      state.paperQueryLoading = false;
      state.error = null;
      state.paperQuery = action.payload.result;
    },
    loadPaperQueryFail(state, action: PayloadAction<{}>) {
      state.paperQueryLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadCustomerQueryRequested,
  loadCustomerQuerySuccess,
  loadCustomerQueryFail,
  loadCustomerActivityLogsRequested,
  loadCustomerActivityLogsSuccess,
  loadCustomerActivityLogsFail,
  loadCustomerActivityLogsByWeeklyRequested,
  loadCustomerActivityLogsByWeeklySuccess,
  loadCustomerActivityLogsByWeeklyFail,
  loadReceiptsRequested,
  loadReceiptsSuccess,
  loadReceiptsFail,
  sendMailRequested,
  sendMailSuccess,
  sendMailFail,
  loadPaperQueryRequested,
  loadPaperQuerySuccess,
  loadPaperQueryFail,
} = reportSlice.actions;

export default reportSlice.reducer;
